autoIdListFactory.$inject = [];

/*******************************************************************************
* @ngdoc    object
* @module   csm.books.InitialSetup.types
* @name     csm.books.InitialSetup.types.type:AutoIDList
*
* @description
* Base class for arrays of objects that need IDs automatically assigned.
* Subclasses call `construct` method to create list, optionally, with a list of
* objects with IDs already assigned. When new objects are added, a new, unique
* ID is assigned.
*******************************************************************************/
/* @ngInject */ export function autoIdListFactory() {
  function AutoIDList() {
    throw "AutoIDList is abstract and can't be instantiated";
  }

  AutoIDList.prototype = Object.defineProperties(
    Object.create(Array.prototype),
    {
      /*-------------------------------------------------------*/
      /* Property of list objects containing auto-assigned ID. */
      /*-------------------------------------------------------*/
      idProperty: { value: 'id' },

      /***************************************************************************
       * construct */
      /**
       * Called by subclass constructor. `args` is `arguments` array. May only be
       * a single object and must be an array. Initializes list to an existing list
       * that already have IDs assigned.
       *
       * @param {string} name Class name.
       * @param {array}  args Constructor arguments.
       ***************************************************************************/
      construct: {
        value: function (name, args) {
          if (args.length > 0)
            if (args.length == 1 && Array.isArray(args[0]))
              Array.prototype.push.apply(this, args[0]);
            else throw 'usage: new ' + name + '([array])';
        }
      },

      /***************************************************************************
       * nextID */
      /**
       * Returns max(idProperty)+1 as the next ID to assign to a new object.
       ***************************************************************************/
      nextID: {
        get: function () {
          var p = this.idProperty;
          return (
            this.reduce(function (id, o) {
              return Math.max(o[p], id);
            }, 0) + 1
          );
        }
      },

      /***************************************************************************
       * push */
      /**
       * Override superclass to assign IDs.
       ***************************************************************************/
      push: {
        value: function () {
          for (var i = 0; i < arguments.length; i++)
            arguments[i][this.idProperty] = this.nextID;

          return Array.prototype.push.apply(this, arguments);
        }
      },

      /***************************************************************************
       * splice */
      /**
       * Override superclass to assign IDs to inserted items.
       ***************************************************************************/
      splice: {
        value: function () {
          if (arguments.length > 2) {
            for (var i = 2; i < arguments.length; i++)
              arguments[i][this.idProperty] = nextID;
          }
          return Array.prototype.splice.apply(this, arguments);
        }
      },

      /***************************************************************************
       * toJSON */
      /**
       * This is an object so this method is necessary to serialize properly.
       ***************************************************************************/
      toJSON: {
        value: function () {
          return this.map(function (e) {
            return e;
          });
        }
      }
    }
  );

  return AutoIDList;
};
